import React, { useContext } from "react";
import { Box, Typography } from "@material-ui/core";
import { ConfigContext } from "../../../contexts/ConfigContext";
import { ProcessContext } from "../../../contexts/ProcessContext";
import { THEME_NAMES } from "../../../config/themes/config";
import { assetTypes } from "../config";
import Text from "./Text";

export default function CaixaBankCardFooter() {
  const {
    state: { themeName },
  } = useContext(ConfigContext);
  const {
    state: { loan },
  } = useContext(ProcessContext);

  const shouldShow =
    themeName === THEME_NAMES.caixabank &&
    loan?.asset_reference?.[0]?.type === assetTypes.CARD;

  if (!shouldShow) return null;

  return (
    <Box pt={2}>
      <Typography
        variant="caption"
        color="textSecondary"
        component="div"
        style={{ fontSize: "0.6rem" }}
      >
        <Text tId="CAIXABANK_CARD_FOOTER" />
      </Typography>
    </Box>
  );
}
